import {helpPopoverRef} from '../../../_shared/Help/constants';
import texts from '../../../_shared/Help/texts';
import {Column} from '../../../stores/Form';
import {getActionHelp, getFieldHelp, getFormHelpText} from '../actions/help';

export type params = {
    anchor: HTMLElement;
    Fname?: string;
    Exec?: number;
    column?: Column;
    portalSelector?: string | HTMLElement;
    strategy?: 'fixed' | 'absolute';
    onLinkClick?: (arg: {eName: string}) => void;
};

export const showHelp = async (props: params) => {
    const {anchor, Fname, column, Exec, onLinkClick, portalSelector, strategy} = props;
    const helpPopover = helpPopoverRef.current;

    if (helpPopover && anchor) {
        let helpData = null;
        if (Exec) {
            helpData = await getActionHelp(Exec);
        } else if (Fname) {
            helpData = column ? await getFieldHelp(Fname, column) : await getFormHelpText(Fname);
        }

        if (!helpData) return;
        // Todo: @i_lavs / @alex_r add correct handlers of the help links
        helpPopover.showHelpPopover({
            title: column ? column.Title + ':' : texts.help,
            content: helpData?.content,
            linkList: helpData?.linkData,
            onLinkClick,
            anchor,
            portalSelector,
            strategy
        });
    }
};
